import { utils } from "../../../util/utils"

/**
 * Recebe uma string normal do campo de texto e responde o texto entre "%"
 * para filtros de busca por trexo
 * @param {String} value valor do input de texto 
 * @returns String
 */
export const formatSearchString = (value) => {
    if (!value) return value
    return `%${value}%`
}


/**
 * recebe objeto com dataInicial e dataFinal e converte em objeto com dataConclusao[ge]
 * e dataConclusao[le]
 * @param {Periodo} value - Valor de período padrão do componente de input de periodo
 * @returns objeto de periodo com a nomenclatura padrão do projeto
 */
export const formatPeriodoConclusao = (value) => {
    if (!value) return
    const newValue = {
        'dataConclusao[ge]': value.dataInicial,
        'dataConclusao[le]': value.dataFinal
    };
    return newValue
}

/**
 * Limpa objeto de query, este método é a limpeza padrão o uso não é obrigatório.
 * Remove itens com arrays vazias
 * Remove objetos que todos os valores são "falsos"
 * remove outros parametros que sejam falsos
 * 
 * no momento o único filtro que gera um objeto complexo são
 * os de período, que temos um tratamento padrão de ignorar
 * se não tiver inicial e final. então se os dois valores
 * não estiverem preenchidos por padrão remove o objeto
 * se os dois estiverem preenchidos faz destruct do objeto
 * para o objeto principal
 * 
 * @param {Object} value objeto de query
 * @returns 
 */
export const clearFilter = (value) => {
    for (let key in value) {
        if (Array.isArray(value[key]) && value[key].length == 0) {
            delete value[key]
            continue
        }
        if (utils.isObject(value[key]) && Object.values(value[key]).every(v => !v)) {
            delete value[key]
            continue
        }
        if (!value[key]) {
            delete value[key]
            continue
        }
        if (utils.isObject(value[key]) && Object.values(value[key]).every(v => !!v)) {
            value = {
                ...value,
                ...value[key]
            }
            delete value[key]
        } else if (utils.isObject(value[key])) {
            delete value[key]
        }
    }
    return value
}

/**
 * Verifica nossas definições padrão de intervalo, e se
 * não forem validas removem os campos referentes do objeto
 * @param {Object} value Objeto de query
 * @returns {Object}
 */
export const clearInvalidIntervals = (value) => {
    if (value.periodo && 
        isIntervaloInvalido(value.periodo.dataInicial, value.periodo.dataFinal)) {
        delete value.periodo
    }
    if (value.dataConclusao && 
        isIntervaloInvalido(value.dataConclusao["dataConclusao[ge]"], value.dataConclusao["dataConclusao[le]"])) {
        delete value.dataConclusao
    }
    if (value.dataInicial && (!value.dataFinal || !isIntervaloInvalido(value.dataInicial, value.dataFinal))) {
        delete value.dataInicial
    }
    if (value.dataFinal && (!value.dataInicial || !isIntervaloInvalido(value.dataInicial, value.dataFinal))) {
        delete value.dataInicial
    }
    if (value["dataConclusao[ge]"] && (!value["dataConclusao[le]"] || !isIntervaloInvalido(value["dataConclusao[ge]"], value["dataConclusao[le]"]))) {
        delete value["dataConclusao[ge]"]
    }
    if (value["dataConclusao[le]"] && (!value["dataConclusao[ge]"] || !isIntervaloInvalido(value["dataConclusao[ge]"], value["dataConclusao[le]"]))) {
        delete value["dataConclusao[le]"]
    }
    return value
}

export const isIntervaloInvalido = (dataInicial, dataFinal) => {
    if (!dataInicial || !dataFinal) return true;

    const startDate = new Date(dataInicial);
    const endDate = new Date(dataFinal);

    return startDate > endDate;
}